module.exports = __webpack_public_path__ + "static/media/21ECLAC10.e3da6749.jpg";